import { CSSProperties } from 'react';

import { useLogoImage } from '~/shared/components/Logo/hooks/useLogoImage';
import { Logo } from '~/shared/components/Logo/Logo';
import { IBrandLogo } from '~/templates/blocks/components/BrandLogo/BrandLogo.def';

import styles from './brandLogo.module.css';

const BrandLogo = ({ logoProps }: IBrandLogo) => {
	const { image, maxHeightScale, maxHeightScaleDesktop } = useLogoImage(logoProps);

	return (
		<div
			className={styles.root}
			style={{ '--maxHeightScale': maxHeightScale, '--maxHeightScaleDesktop': maxHeightScaleDesktop } as CSSProperties}
		>
			<Logo image={image} />
		</div>
	);
};

export default BrandLogo;
